import styled from 'styled-components';
import { Typography } from '@_shared/ui/Typography';

export const Form = styled.form`
	width: 100%;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 14px;

	position: relative;
`;

export const TextContainer = styled.div`
	width: 100%;

	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;

	position: relative;
`;

export const SummitButton = styled.button`
	padding: 6px;

	position: absolute;
	right: -6px;

	display: flex;
	justify-content: center;
	align-items: center;

	background-color: inherit;
	border: none;
`;

export const InputContainer = styled.div`
	width: 100%;
	padding-bottom: 4px;

	position: relative;

	display: flex;
	justify-content: flex-start;
	align-items: center;

	border-bottom: 1px solid ${({ theme }) => theme['warmgray-200']};

	input {
		border: none;
		outline: none;

		width: 100%;

		color: var(--Font-Secondary, #504c49);

		font-family: 'Pretendard';
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
	}

	input::placeholder {
		color: ${({ theme }) => theme['font-tertiary']};
		font-family: 'Pretendard';
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
	}
`;

export const Counter = styled(Typography)`
	position: absolute;
	right: 32px;
`;

export const LoadingWrapper = styled.div`
	width: 100%;
	height: 100%;
	/* border-radius: 10px; */
	background-color: rgba(0, 0, 0, 0.5);
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	svg {
		width: 72px;
		height: 72px;
	}
`;
